import React, { memo } from 'react';
import styles from './WavesBackground.module.css';

// Memoize the waves component to prevent unnecessary re-renders
const WavesBackground = memo(() => {
    return (
      <div className={styles.waves}>
        {[...Array(3)].map((_, index) => (
          <div 
            key={index} 
            className={styles.wave} 
            style={{ 
              animationDelay: `${index * 0.3}s`,
              opacity: 1 - (index * 0.15)
            }}
          />
        ))}
      </div>
    );
  });
  
  WavesBackground.displayName = 'WavesBackground';

  export default WavesBackground;